import { render, staticRenderFns } from "./center-slider.vue?vue&type=template&id=5c3dbd45"
import script from "./center-slider.vue?vue&type=script&lang=js"
export * from "./center-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports